import { render, staticRenderFns } from "./activitiesList.vue?vue&type=template&id=f3f520f4&scoped=true&"
import script from "./activitiesList.vue?vue&type=script&lang=js&"
export * from "./activitiesList.vue?vue&type=script&lang=js&"
import style0 from "./activitiesList.vue?vue&type=style&index=0&id=f3f520f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f520f4",
  null
  
)

export default component.exports